import React, { useState } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider, useFormikContext } from 'formik';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  Container,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Backdrop,
  Grid,
  FormGroup,
  FormControlLabel,
  Switch,
  Button
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import { useSettingContext } from '../../context/setting_context';
import Controls from '../controls/Controls';
import { baseUrl } from '../../utils/constants';

export default function TemplateSetup() {
  const { currentTemplate, setCurrentTemplate } = useSettingContext();
  const [loading, setLoading] = useState(false);
  const [toggle, setToggle] = useState(Boolean(currentTemplate.status));
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const navigate = useNavigate();

  console.log('template received', currentTemplate);
  const AccountRequirementsDetailsSchema = Yup.object().shape({
    templateName: Yup.string()
      .min(2, 'Template Name is too Short!')
      .max(50, 'Template Name is too Long!')
      .required('Template name required'),
    notificationType: Yup.number().required('NotificationType is required')
  });

  const formik = useFormik({
    initialValues: currentTemplate,
    enableReinitialize: true,
    validationSchema: AccountRequirementsDetailsSchema,
    onSubmit: (values) => {
      console.log('new values', values);
      // setCurrentTemplate(values);
      setLoading(true);
      values.notificationsTypes = {};
      values.notificationCategories = {};
      saveTemplate(values);
    }
  });

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const saveTemplate = (templateData) => {
    const jsonClient = [];
    jsonClient.push(templateData);
    console.log('temp save', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/Setting/SaveNotificationTemplate?create=false`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          navigate('/settings/templates');
        },
        (error) => {
          alert(`Fata Error in Saving Templates!${error}`);
        }
      );
  };

  return (
    <Container>
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate>
          <Card>
            <CardContent>
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
                onClick={handleLoadingClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Typography component="span" variant="h4" gutterBottom>
                Notification Template...
              </Typography>

              <Grid container spacing={2} marginBottom={2} marginTop={2}>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="templateName" label="Template Name" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.SelectJsonApi
                    name="notificationType"
                    label="Template Type"
                    options={currentTemplate.notificationsTypes.lookupList}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.SelectJsonApi
                    name="category"
                    label="Template Category"
                    options={currentTemplate.notificationCategories.lookupList}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.SelectJsonApi
                    name="notificationDeliveryTypeId"
                    label="Delivery Type"
                    options={currentTemplate.notificationDeliveryTypes.lookupList}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="messageSubject" label="Message Subject" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          name="status"
                          checked={toggle}
                          // onChange={handleChange}
                        />
                      }
                      label="Active"
                    />
                  </FormGroup>
                </Grid>
              </Grid>
              <Typography component="span" variant="subtitle1" gutterBottom>
                Edit Html Body
              </Typography>
              <CKEditor
                editor={Editor}
                data={currentTemplate.messageBody} // "<p>Hello from CKEditor 5!</p>"
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  console.log('Editor is ready to use!', editor);
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  console.log({ event, editor, data });
                }}
                onBlur={(event, editor) => {
                  const data = editor.getData();
                  console.log('Blur.', data);
                  formik.setFieldValue('messageBody', data);
                }}
                onFocus={(event, editor) => {
                  console.log('Focus.', editor);
                }}
              />
            </CardContent>
          </Card>
          <Grid container margin={2} direction="row" justifyContent="right" alignItems="right">
            <Grid item xs={12} sm={2}>
              <Button type="submit" variant="outlined" startIcon={<SaveIcon />}>
                Save Template
              </Button>
            </Grid>
          </Grid>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </Form>
      </FormikProvider>
    </Container>
  );
}
